import CryptoJS from "crypto-js";

const { REACT_APP_SECRETKEY } = process.env;

// AES 암호화
export const encryptData = (data) => {
  try {
    return CryptoJS.AES.encrypt(
      JSON.stringify(data),
      REACT_APP_SECRETKEY
    ).toString();
  } catch (error) {
    console.error("암호화 오류:", error);
    return "Encryption Error"; // 암호화 실패 시 기본 메시지 반환
  }
};

// AES 복호화
export const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, REACT_APP_SECRETKEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText); // JSON 형식으로 변환
  } catch (error) {
    console.error("복호화 오류:", error);
    console.error("복호화 오류 data:", encryptedData);
    return "Decryption Error"; // 복호화 실패 시 기본 메시지 반환
  }
};
